// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chargeback-page {
  width: 100%;
  height: 100%;
  padding: 20px;
}
.chargeback-page .chargeback-details * {
  font-size: 17px !important;
}
.chargeback-page .chargeback-details .label-column {
  margin-right: 20px;
  width: 200px;
}
.chargeback-page .chargeback-details .value-column {
  width: 200px;
}
.chargeback-page .reason-section {
  margin-top: 20px;
}
.chargeback-page .reason-section .summary-reason {
  margin-bottom: 20px;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.chargeback-page .reason-section .summary-reason span {
  font-size: 17px !important;
}
.chargeback-page .reason-section .reason {
  word-wrap: break-word;
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./src/app/main/data/chargebacks/chargeback/index.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AACF;AAJA;EAMM,0BAAA;AACN;AAPA;EASM,kBAAA;EACA,YAAA;AACN;AAXA;EAaM,YAAA;AACN;AAdA;EAiBI,gBAAA;AAAJ;AAjBA;EAmBM,mBAAA;EACA,qBAAA;EACA,qBAAA;AACN;AAtBA;EAwBQ,0BAAA;AACR;AAzBA;EA4BM,qBAAA;EACA,qBAAA;AAAN","sourcesContent":[".chargeback-page {\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  .chargeback-details {\n    * {\n      font-size: 17px !important;\n    }\n    .label-column {\n      margin-right: 20px;\n      width: 200px;\n    }\n    .value-column {\n      width: 200px;\n    }\n  }\n  .reason-section {\n    margin-top: 20px;\n    .summary-reason {\n      margin-bottom: 20px;\n      word-wrap: break-word;\n      white-space: pre-wrap;\n\n      span {\n        font-size: 17px !important;\n      }\n    }\n    .reason {\n      word-wrap: break-word;\n      white-space: pre-wrap;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
